<template>
  <div id="hrms17e" class="clearfix">
    <hrms-search-box-table v-show="indexDisp"
            v-model="searchIndex"
            :data="index"
            :nowLang="app.nowLang"
            :columns="columns[app.nowLang].index"
            :unLoadBool="true"
            :receivedStore="receivedHrms17eIndex"
            searchBoxAlias="hrms17e"
            :addEvent="addEvent"
            :editEvent="editEvent"
            :deleteInlineEventBool="true"
            :deleteInlineBtnDisp="false"
            :saveInlineEvent="deleteEvent"
            :xlsImportDisp="true"
            :postImport="postHrms17eImport"
            :resultImport="resultImport"
            :fileSample="'hrap32e.xls'"
            :callSearchEvent="callSearchEvent" />

    <detail v-show="detail1Disp || detail2Disp"
            :labels="labels[app.nowLang]"
            :labelsButton="app.button[app.nowLang]"
            :maxRowspan="maxRowspan.detail2Tab2Table"
            :detail1="detail1"
            :detail2="detail2"
            :descCodempid="descCodempid"
            :nowLang="app.nowLang"
            :toggle="toggle"
            :eventBtn="eventBtn"
            :indexSelected="indexSelected"
            :searchIndex="searchIndex"
            :searchParamsIndex="searchParamsIndex"
            :detail1Selected="detail1Selected"
            :inlineDetail2Tab1="inlineDetail2Tab1"
            :inlineDetail2Tab2="inlineDetail2Tab2"
            :setDetail1Selected="setDetail1Selected"
            :setInlineDetail2Tab1="setInlineDetail2Tab1"
            :setInlineDetail2Tab2="setInlineDetail2Tab2"
            :detail1Disp="detail1Disp"
            :detail2Disp="detail2Disp"
            :detail1Table="columns[app.nowLang].detail1Table"
            :detail2Tab1Table="columns[app.nowLang].detail2Tab1Table"
            :detail2Tab2Table="columns[app.nowLang].detail2Tab2Table"
            :receivedHrms17eDetail2Create="receivedHrms17eDetail2Create"
            :receivedHrms17eDetail2="receivedHrms17eDetail2"
            :receivedHrms17eCodempid="receivedHrms17eCodempid"
            :receivedHrms17eDetail="receivedHrms17eDetail"
            :postHrms17eDetail1TableDelete="postHrms17eDetail1TableDelete"
            :codempidQuery="codempidQuery"
            :postDetail2Save="postDetail2Save"
            :setDetail1Disp="setDetail1Disp"
            :setDetail2Disp="setDetail2Disp"
            :dropdowns="dropdowns"
             />
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import * as types from 'store/modules/hrms17e/mutation-types'
import * as lovTypes from 'store/modules/hrmsLov/mutation-types'
import * as lovCodcompTypes from 'store/modules/hrmsLovCodcomp/mutation-types'
import detail from 'components/hrms17e/detail1'
import moment from 'moment'

export default {
  name: 'hrms17e',
  data: function () {
    return {
      app: this.$root.$children[0],
      searchIndex: {
        year: moment().format('YYYY'),
        numtime: '1',
        codcomp: '',
        codpos: '',
        codempid: '',
        codempid2: '',
        dteappr: moment().format('DD/MM/YYYY')
      },
      searchParams: {
        p_codempid: ''
      },
      eventBtn: '',
      sheet: 1
    }
  },
  created: function () {
    this.searchIndex.codempid2 = this.app.currentUser.p_codempid
    this.receivedHrms17eColumnsLabels()
    this.receivedHrms17eDropdowns()
  },
  computed: {
    codempid () {
      let currentUser = this.app.currentUser
      return currentUser.p_codempid
    },
    ...mapGetters({
      indexDisp: types.GET_HRMS17E_INDEX_DISP,
      detail1Disp: types.GET_HRMS17E_DETAIL1_DISP,
      detail2Disp: types.GET_HRMS17E_DETAIL2_DISP,
      columns: types.GET_HRMS17E_COLUMNS,
      labels: types.GET_HRMS17E_LABELS,
      lovCurrentDesc: lovTypes.GET_LOV_CURRENT_DESC,
      lovCodcompCurrentDesc: lovCodcompTypes.GET_LOV_CODCOMP_CURRENT_DESC,
      maxRowspan: types.GET_HRMS17E_MAX_ROWSPAN,
      index: types.GET_HRMS17E_INDEX,
      searchParamsIndex: types.GET_HRMS17E_SEARCH_PARAMS_INDEX,
      indexSelected: types.GET_HRMS17E_INDEX_SELECTED,
      detail1Selected: types.GET_HRMS17E_DETAIL1_SELECTED,
      inlineDetail2Tab1: types.GET_HRMS17E_INLINE_DETAIL2_TAB1,
      inlineDetail2Tab2: types.GET_HRMS17E_INLINE_DETAIL2_TAB2,
      detail1: types.GET_HRMS17E_DETAIL,
      detail2: types.GET_HRMS17E_DETAIL2,
      codempidQuery: types.GET_HRMS17E_CODEMPID,
      dropdowns: types.GET_HRMS17E_DROPDOWNS,
      resultImport: types.GET_HRMS17E_IMPORT
    })
  },
  methods: {
    pageDetail (event) {
      switch (event) {
        case 'add':
          let searchParams = {
            p_dteyreap: this.searchIndex.year,
            p_numtime: this.searchIndex.numtime
          }
          this.eventBtn = 'add'
          this.receivedHrms17eCreate(searchParams)
          this.toggle('detail1')
          break
        case 'edit':
          let editParams = {
            p_dteyreap: this.searchIndex.year,
            p_numtime: this.searchIndex.numtime,
            p_codempid_query: this.indexSelected.codempid
          }
          this.descCodempid = this.lovCurrentDesc('codempid', this.indexSelected.codempid)
          this.eventBtn = 'edit'
          this.receivedHrms17eDetail(editParams)
          this.toggle('detail1')
          break
        default:
          break
      }
    },
    addEvent () {
      this.setIndexSelected({
        codempid: '',
        codcomp: '',
        codpos: ''
      })
      this.pageDetail('add')
    },
    editEvent (param) {
      this.setIndexSelected(param)
      this.pageDetail('edit')
    },
    deleteEvent (dataRowsHasFlg) {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.postHrms17eDelete({ searchIndex: this.searchIndex, dataRowsHasFlg: dataRowsHasFlg, indexSelected: this.indexSelected })
        }
      })
    },
    callSearchEvent () {
      if (this.searchIndex.codempid3 !== '') {
        this.searchIndex.codcomp = ''
        this.searchIndex.codpos = ''
      }
    },
    ...mapMutations({
      setIndexSelected: types.SET_HRMS17E_INDEX_SELECTED,
      setDetail1Selected: types.SET_HRMS17E_DETAIL1_SELECTED,
      setDetail1Disp: types.SET_HRMS17E_DETAIL1_DISP,
      setDetail2Disp: types.SET_HRMS17E_DETAIL2_DISP,
      setInlineDetail2Tab1: types.SET_HRMS17E_INLINE_DETAIL2_TAB1,
      setInlineDetail2Tab2: types.SET_HRMS17E_INLINE_DETAIL2_TAB2
    }),
    ...mapActions({
      toggle: types.TOGGLE_HRMS17E_PAGE,
      receivedHrms17eColumnsLabels: types.RECEIVED_HRMS17E_COLUMNS_LABELS,
      receivedHrms17eIndex: types.RECEIVED_HRMS17E_INDEX,
      receivedHrms17eCreate: types.RECEIVED_HRMS17E_CREATE,
      receivedHrms17eDetail: types.RECEIVED_HRMS17E_DETAIL,
      receivedHrms17eDetail2Create: types.RECEIVED_HRMS17E_DETAIL2_CREATE,
      receivedHrms17eDetail2: types.RECEIVED_HRMS17E_DETAIL2,
      receivedHrms17eCodempid: types.RECEIVED_HRMS17E_CODEMPID,
      postHrms17eDetail1TableDelete: types.POST_HRMS17E_DETAIL1_TABLE_DELETE,
      postDetail2Save: types.POST_HRMS17E_DETAIL2_SAVE,
      postHrms17eDelete: types.POST_HRMS17E_DELETE,
      postHrms17eImport: types.POST_HRMS17E_IMPORT,
      receivedHrms17eDropdowns: types.RECEIVED_HRMS17E_DROPDOWNS
    })
  },
  components: {
    detail
  }
}
</script>



// WEBPACK FOOTER //
// component.vue?79d02781